export function speechAvailable() {
  return typeof window !== "undefined" && "speechSynthesis" in window;
}

export function speak(text, { lang = "en-US", rate = 0.75 } = {}) {
  if (!speechAvailable()) return false;
  try {
    window.speechSynthesis.cancel();
    const utter = new SpeechSynthesisUtterance(text);
    utter.lang = lang;
    utter.rate = rate;
    utter.pitch = 1.1;
    window.speechSynthesis.speak(utter);
    return true;
  } catch (e) {
    return false;
  }
}
